module.exports = __webpack_public_path__ + "1cabe18f42855497f071e007a4bc9dec.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/ok_button.png
// module id = 199
// module chunks = 0